module.exports = `
  type Superadmin {
    access_token: String
    done: Boolean
  }
`;
